import { Component, Input, Output, EventEmitter  } from '@angular/core';
import { MenuTemplateComponent } from '../menu/menu-template/menu-template.component';

export interface OrderMenuItem {
  id: string;
  data: {title: string; price: string; qty: number; showDescription?: boolean; description?: string; [key: string]: unknown};
}

@Component({
    selector: 'app-order-template',
    templateUrl: './order-template.component.html',
    styleUrls: ['./order-template.component.scss'],
    imports: []
})
export class OrderTemplateComponent extends MenuTemplateComponent{

  @Output() menuClicked: EventEmitter<OrderMenuItem> = new EventEmitter<OrderMenuItem>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() override menuItems: any[] = [];

  menuItemClicked(m: OrderMenuItem){
    this.menuClicked.emit(m);
  }
}

